import { FC, useState } from 'react'
import { UserInfo, MeetingDashboardFragment, EmployeeCloseMeetingInput, MeetingStatus, ObjectiveAttachmentInfoDto } from '../../../../types'
import { useEmployeeCloseAppraisalMeeting } from '../../../../graphql/meeting/hooks/useEmployeeCloseAppraisalMeeting'
import { EmployeeCloseMeetingModal } from './EmployeeCloseMeetingModal'
import { PerInfoBoxMeetingElement, MeetingTile } from '../../../../components/custom_components/InfoBox/InfoBoxMeetingElement'
import ManagerMeetingActionButton from '../../Table/ManagerMeetingActionButton'
import { EmployeeMeetingActionButton } from '../../Table/EmployeeMeetingActionButton'
import EmployeeMeetingStatus from '../../../meeting/EmployeeMeetingStatus'
import { useObjectivesWithAttachmentsFromMeeting } from '../../../../graphql/objectives/useObjectivesWithAttachmentsFromMeeting'

interface Props {
  user: UserInfo
  meeting: MeetingDashboardFragment
  employeeView?: boolean
  withManagerOptions?: boolean
}

export const EmployeeMeetingTile: FC<Props> = ({ user, meeting, employeeView, withManagerOptions }) => {
  const [open, setOpen] = useState<boolean>(false)
  const [isConfirming, setIsConfirming] = useState<boolean>(false)
  const { employeeCloseMeeting, loading } = useEmployeeCloseAppraisalMeeting()
  const { data } = useObjectivesWithAttachmentsFromMeeting(meeting.id)

  const objectivesFromMeeting: ObjectiveAttachmentInfoDto[] = !!data ? data.objectivesWithAttachmentsFromMeeting : []

  const setConfirmModalOpen = () => {
    setOpen(true)
  }

  const closeMeeting = async (meetingInput: EmployeeCloseMeetingInput) => {
    const closeMeetingResult = await employeeCloseMeeting(meetingInput)
    if (closeMeetingResult && !closeMeetingResult.errors) {
      setOpen(false)
      setIsConfirming(true)
    }
  }

  const isEmployee = user.employeeId === meeting.employee.id
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const isManager = user.employeeId === meeting.reviewer!.id
  const isNotPartOfMeeting = !isEmployee && !isManager

  const showOnlyStatus = isNotPartOfMeeting || (isManager && meeting.status === MeetingStatus.PendingConfirmation)

  return (
    <>
      {employeeView && (
        <EmployeeCloseMeetingModal
          meeting={meeting}
          visible={open}
          closeModal={() => setOpen(false)}
          onCloseMeeting={closeMeeting}
          loading={loading}
          objectivesWithAttachments={objectivesFromMeeting}
        />
      )}
      <PerInfoBoxMeetingElement
        meeting={meeting as MeetingTile}
        user={user}
        employeeView={employeeView}
        actionButton={
          <>
            {!showOnlyStatus && withManagerOptions ? (
              <ManagerMeetingActionButton meeting={meeting} type="rectangular" />
            ) : !showOnlyStatus ? (
              <EmployeeMeetingActionButton
                meeting={meeting}
                timezoneAndLocale={user}
                setConfirmModalOpen={setConfirmModalOpen}
                isLoading={loading}
                isConfirming={isConfirming}
              />
            ) : (
              <EmployeeMeetingStatus
                firstName={meeting.employee.chosenFirstName ? meeting.employee.chosenFirstName : meeting.employee.legalFirstName}
                meetingStatus={meeting.status}
                employeePrepared={meeting.employeePrepared}
                withText
              />
            )}
          </>
        }
      />
    </>
  )
}
